import { useContext } from 'react'

import { CommonGAssets } from '@hhgtech/hhg-components/gAssets'
import { AspectRatio, Box, BoxProps, Flex } from '@mantine/core'

import ArrowDownTail from 'components/atoms/icons/ArrowDownTail'
import { RichTextFormat } from 'components/atoms/richTextFormat'
import { AppDownloadInfoCard } from 'components/molecules/appDownloadInfoCard'
import { AppIntroNav } from 'components/molecules/appIntroNav'
import { handleScrollToBlock } from 'components/templates/carePath/helpers'
import { CarePathDefaultContext } from 'components/templates/carePath/landing/context'
import { useIsMobile } from 'hooks/useIsMobile'

import useStyles from './index.styles'

type Props = {
  title: string
  banner: string
  headerDescription: string
  innerClass?: string
  descInnerClass?: string
  onNavClick?: any
  logo?: {
    icon: string
    url: string
  }
} & BoxProps

export const AppIntroHeroBanner = ({
  title,
  banner,
  headerDescription,
  innerClass = '',
  descInnerClass = '',
  onNavClick,
  logo,
  styles,
  className,
  classNames,
  ...rest
}: Props) => {
  const { classes, cx } = useStyles(undefined, {
    name: 'AppIntroHeroBanner',
    styles,
    classNames,
  })
  const { navigating } = useContext(CarePathDefaultContext)
  const isMobile = useIsMobile()
  return (
    <div className={cx(className, classes.root)} {...rest}>
      <div className={classes.banner}>
        <div className={cx(innerClass, classes.inner)}>
          {!isMobile && (
            <AppIntroNav
              navigating={navigating}
              onNavClick={onNavClick}
              selectedSection="tong-quan"
              logo={logo}
              className={classes.nav}
            />
          )}
          <div className={classes.body}>
            <div className={classes.bodyInner}>
              <div className={classes.info}>
                {title && <h1 className={classes.heading}>{title}</h1>}
                <AppDownloadInfoCard url={logo?.url} />
              </div>
              {banner && (
                <div className={classes.bannerImageFrame}>
                  <div className={classes.bannerImageFrameInner}>
                    <div className={classes.bannerImageFrameInnerInner}>
                      <img
                        loading="lazy"
                        src={banner}
                        className={classes.thumbnail}
                        alt={title}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <Flex justify={'center'} className={classes.scrollToNext}>
          <button
            onClick={() =>
              handleScrollToBlock({
                hash: 'hero-description',
                isMobile,
              })
            }
            className={classes.scrollToNextBtn}
          >
            <AspectRatio ratio={1} className={classes.scrollToNextThumb}>
              <img
                src={CommonGAssets.getAssetPath('appIntro/circle-logo.svg')}
                alt="Health app qrcode"
                loading="lazy"
                className={classes.scrollToNextLogo}
              />
              <Flex
                align={'center'}
                justify={'center'}
                className={classes.scrollToNextFrame}
              >
                <ArrowDownTail
                  color={'currentColor'}
                  className={classes.scrollToNextIcon}
                  size={isMobile ? 28 : 32}
                />
              </Flex>
            </AspectRatio>
          </button>
        </Flex>
      </div>
      {headerDescription && (
        <Box
          className={classes.heroDesc}
          data-hashtag="hero-description"
          data-gap={40}
        >
          <RichTextFormat
            className={cx(descInnerClass, classes.inner)}
            content={headerDescription}
          />
        </Box>
      )}
    </div>
  )
}
